module.exports = __webpack_public_path__ + "img/gzrw1.9abbf7e3.png";